import { Badge, type BadgeVariant } from "@fox1ck-org/ui";
import { CampaignStatus } from "@gen/tracker/v1/campaign_pb";

import { useT, type TKey } from "@/lib/i18n";

const STATUS: Partial<Record<CampaignStatus, { label: TKey; variant: BadgeVariant; dot?: boolean }>> = {
  [CampaignStatus.ACTIVE]: { label: "campaigns.badge.active", variant: "ok", dot: true },
  [CampaignStatus.PAUSED]: { label: "campaigns.badge.paused", variant: "neutral", dot: true },
  [CampaignStatus.DRAFT]: { label: "campaigns.badge.draft", variant: "outline" },
  [CampaignStatus.ARCHIVED]: { label: "campaigns.badge.archived", variant: "outline" },
};

/** The status word for CSV and screen readers. */
export function campaignStatusKey(status: CampaignStatus | undefined): TKey | undefined {
  return status === undefined ? undefined : STATUS[status]?.label;
}

/**
 * A campaign's status as a word, never a switch: the list is read-only
 * (owner, 14.10) and the card changes status from its «⋯» menu, so the one
 * badge serves both.
 */
export function CampaignStatusPill({ status }: { status: CampaignStatus | undefined }) {
  const t = useT();
  const s = status === undefined ? undefined : STATUS[status];
  return s ? (
    <Badge variant={s.variant} dot={s.dot} size="sm">
      {t(s.label)}
    </Badge>
  ) : null;
}
